module.exports = __webpack_public_path__ + "components/weather-icon/static/daysnowshowers@2-8344f7419ba8062f9c7c0e95a6577d1f.png";